import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[vcpCardHover]'
})
export class CardHoverDirective {
  @Input() index;
  constructor() { }

  @HostListener('mouseleave', ['$event']) onDragOver() {
    this.toggleInfo(this.index);
  }

  toggleInfo(index) {
    const elem: HTMLElement = document.getElementById(`showOption${index}`);
    elem.classList.remove('display-block');
  }
}
